"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames = require("classnames");
var React = require("react");
require("./theme.scss");
//  Don't forget to put this link in the html
//  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
function MaterialIcon(_a) {
    var iconName = _a.iconName, className = _a.className, style = _a.style, _b = _a.size, size = _b === void 0 ? "2.4rem" : _b, others = tslib_1.__rest(_a, ["iconName", "className", "style", "size"]);
    return (React.createElement("i", tslib_1.__assign({}, others, { style: tslib_1.__assign({ fontSize: size }, style), className: classnames("material-icons", className) }), iconName));
}
exports.default = MaterialIcon;
